import { render } from "./SpotifyAuth.vue?vue&type=template&id=5d87cee3"
import script from "./SpotifyAuth.vue?vue&type=script&lang=js"
export * from "./SpotifyAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__